//Convert RGB to Hex
export const rgbToHex = (r, g, b) => {
  const hex =
    "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  return hex;
};
